import { useCallback, useEffect, useRef } from 'react';
import { TOCNode } from '../../../types';
import { useSessionContext } from '../../SessionContext';
import { ChapterNavigationDirection } from './types';
import TextVariant from './TextVariant';
import IconVariant from './IconVariant';

function Button({
  chapter,
  direction,
  variant,
}: Readonly<{
  chapter: TOCNode;
  direction: ChapterNavigationDirection;
  variant: 'icon' | 'text';
}>) {
  const { navigateToChapter, navigationState } = useSessionContext();
  const isLoadingRef = useRef(false);

  const handleClick = useCallback(() => {
    if (isLoadingRef.current) {
      return;
    }
    isLoadingRef.current = true;
    void navigateToChapter({ chapter });
  }, [chapter, navigateToChapter]);

  useEffect(() => {
    if (navigationState === 'ready') {
      isLoadingRef.current = false;
    }
  }, [navigationState]);

  return variant === 'icon' ? (
    <IconVariant
      direction={direction}
      onClick={handleClick}
      loading={isLoadingRef.current}
    />
  ) : (
    <TextVariant
      chapter={chapter}
      direction={direction}
      onClick={handleClick}
      loading={isLoadingRef.current}
    />
  );
}

export default Button;
